import { FC, useCallback, useContext, useEffect, useMemo, useState } from "react";
import styles from "./styles.module.scss";
import { useRouter } from "next/router";
import { NavType } from "../../navbar";
import cName from "classnames";
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation';
import { IndexContext } from "@/stores";
import classNames from "classnames";
import { Breadcrumb } from "@douyinfe/semi-ui";
import searchNode from "@/utils/searchNode";
import { useTranslations } from "next-intl";


type CrumbType = {
  path: string,
  name: string,
}

export interface ILayoutProps {
  crumb?: CrumbType[],
  banner?: string;
  partPath?: string | undefined | null;
}


export const PageCrumb: FC<ILayoutProps> = ({
  crumb = [],
  banner = '/image/page-banner.png',
  partPath
}) => {
  const { nav } = useContext(IndexContext)
  const [menu, setMenu] = useState<NavType>()
  const [active, setActive] = useState<NavType>()
  const router = useRouter()
  const [isVideo, setIsVideo] = useState(false)
  const t = useTranslations();

  const navTo = useCallback((e: any, item: NavType): void => {
    if (router.asPath == item.path) {
      return
    }
    e.stopPropagation();
    // if (item.path === '/audience/register') {
    //   setVisible(true)
    //   return
    // }
    if (item.out_link) {
      const a = document.createElement("a")
      a.href = `${item.out_link}`
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      return
    }
    router.push(item.path as any, item.path as any, {
      shallow: true
    })
  }, [active, nav])

  useEffect(() => {
    console.log(crumb);

    const act = searchNode(nav, partPath || router.asPath)
    setActive(act)
    const item = nav?.find(item => item.id === act?.parent)
    setMenu(item)
  }, [nav])

  console.log(router);


  return (
    <div className={styles.page}>
      <div className={styles.banner}>
        <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src={banner} loading='lazy' alt="" />
        <div className={styles.title}>
          <div>
            <h1 style={{
              transform: router.locale === 'cn' ? 'translateY(-20px)' : 'translateY(-35px)'
            }}>{active?.name}</h1>
            {
              menu?.children
              && menu.children.length > 1
              && !(router.locale === 'en' && router.asPath.includes('/event'))
              && (
                menu.children.length == 1 ? <h1>{menu?.children[0].name}</h1> : (
                  <ul className={cName([styles.pageNav])}>
                    {
                      menu?.children?.map(item => (

                        <li key={item.id} style={{
                          zIndex: '100',
                          background: item.id === active?.id ?
                            '#6354a2'
                            : '',
                        }} onClick={(e) => navTo(e, item)}>
                          <span>{item.name}</span>
                        </li>
                      ))
                    }
                  </ul>
                )
              )
            }
          </div>

        </div>
      </div>
      <div className={styles.pageHeader}>
        <div className={styles.crumb}>
          <a href="/"><img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src="/image/home.png" alt="" /></a>
          <Breadcrumb
            compact={false}
            routes={
              [
                {
                  path: '/',
                  name: ''
                },
                {
                  path: active?.path || menu?.path || '',
                  name: menu?.name || '',
                  isShow: !menu
                },
                {
                  path: active?.path || '',
                  name: active?.name || '',
                  isShow: !active
                },
                ...crumb
              ].filter((item: any) => !item.isShow) as any
            }
            onClick={(item) => {
              router.push(item.path as any, item.path as any, {
                shallow: true
              })
            }
            }
            separator={'>'} />
        </div>
        <Swiper
          className={classNames([styles.swiper, 'minShow', 'mobileSwiper'])}
          modules={[]}
          spaceBetween={0}
          slidesPerView="auto"
          style={{ display: 'none' }}
        >
          {
            menu?.children
            && menu.children.length > 1
            && (
              menu.children.length == 1 ? <h1>{menu?.children[0].name}</h1> : (
                <div>
                  {
                    menu?.children?.map(item => (
                      <SwiperSlide key={item.id}>
                        <div
                          className={styles.swiperList}
                          style={{
                            zIndex: '100',
                            background: item.id === active?.id ?
                              '#6354a2'
                              : '',
                            padding: '0 15px',
                            color: item.id === active?.id ? 'white' : '#6354a2'
                          }} onClick={(e) => navTo(e, item)}>{item.name}</div>
                      </SwiperSlide>
                    ))
                  }
                </div>
              )
            )
          }

          <SwiperSlide></SwiperSlide>
        </Swiper>
      </div>
      <style jsx global>
        {
          `
          .mobileSwiper .swiper-slide{
            width:auto !important;
          }
          .semi-typography{
            font-size:20px;
          }
          .semi-breadcrumb-item-title .semi-typography{
            max-width: none !important;
            line-height: 1.5 !important;
          }
          `
        }
      </style>
    </div>
  );
};
